export const CONTACT = {
  offices: [
    {
      label: 'United Kingdom — Head Office',
      lines: ['71-75 Shelton Street', 'Covent Garden', 'London WC2H 9JQ', 'United Kingdom'],
      primary: true,
    },
    {
      label: 'South Africa',
      lines: ['V&A Waterfront', 'Dock Road Junction', 'Cape Town 8001', 'South Africa'],
      primary: false,
    },
  ],
  officePhone: '+44 (0)20 3148 4620',
  officePhoneHref: 'tel:+442031484620',
  mobilePhone: '+27 81 754 1908',
  mobilePhoneHref: 'tel:+27817541908',
  bookings: 'bookings@ahana.digital',
  sales: 'sales@ahana.digital',
  support: 'support@ahana.digital',
  calendly: 'https://calendly.com/ahanadigital/30min',
};